import { EntityAssumptionValue } from '@portal/pkg-api/gen/navigator'
import { NavigatorApi } from '@portal/pkg-api/navigator'
import { UserNotificationType } from '@migrate/stores/UserNotificationStore'
import { AxiosError } from 'axios'
import { addNotification } from '@migrate/utils/notification'

export const updateEntityAssumptionValue = async (
  entityId: number,
  value: EntityAssumptionValue,
) => {
  try {
    await NavigatorApi.updateEntityAssumption(entityId, parseFloat(value.identifier), value, {
      mercatusNotifyOnError: false,
    })
  } catch (e: unknown) {
    const errorText =
      e instanceof AxiosError && typeof e.response?.data === 'string'
        ? e.response.data
        : 'navigator.detail.errorSaving'
    addNotification(UserNotificationType.ERROR, errorText)
    throw e
  }
}
